import { validatorPermitirPetsComValorAdicionalEdicao, validatorPermitirSomente3PetsSemValorAdicionalEdicao } from './funcoesAuxiliaresZPET';

export class CorrenteEdicaoZPET {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }

    permitirPetsComValorAdicionalEdicao(){
        if(validatorPermitirPetsComValorAdicionalEdicao(this.valoresForm, this.dependentes))
        {
            this.arrayMsgsErro.push('Com mais de 3 dependentes no plano ZPET 3 devem ser sem valor adicional');
        }

        return this;
    }

    permiteApenasDepentesTipoPet(){
        if(this.valoresForm.Parentesco.trim() !== 'PET'){
            this.arrayMsgsErro.push('Este plano permite apenas parentesco do tipo PET (ANIMAL)');
        }

        return this;
    }

    permitirSomente3PetsSemValorAdicional(){
        if(validatorPermitirSomente3PetsSemValorAdicionalEdicao(this.valoresForm, this.dependentes)){
            this.arrayMsgsErro.push('Este plano permite apenas 3 dependentes sem valor adicional');
        }

        return this;
    }
}
